var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n    font-family: klavika;\n    src: url(" + escape(require("./KlavikaLight.ttf")) + ") format(\"opentype\");\n  }\n\n  @font-face {\n    font-family: klavikaBold;\n    src: url(" + escape(require("./KlavikaBold.ttf")) + ") format(\"opentype\");\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/css-loader?{"sourceMap":false,"import":false}!/var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/fonts/klavika_font/klavika.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/fonts/klavika_font/klavika.css
// module chunks = styles